<template>
	<div>
		<div style="text-align: left; padding-bottom: 10px;">
			<el-row :gutter="2">
					<el-col :span="6">
							<el-input v-model="endStand" class="" placeholder="到达站名称"></el-input>
					</el-col>
					<el-col :span="12">
						
						<el-button type="primary" @click="searchLine">查询</el-button>

						<el-button type="primary" @click="addLine">添加线路</el-button>
						
					</el-col>
				</el-row>
			
		</div>
		<div>
			<el-table :data="tableData" style="width: 100%" border stripe>
				<el-table-column prop="id" label="编号" width="50"></el-table-column>
	      		<el-table-column prop="startCity" label="出发城市" width="180"></el-table-column>
	      		<el-table-column prop="endCity" label="到达城市" width="150"></el-table-column>
	      		<el-table-column prop="telephone" label="联系电话" width="180"></el-table-column>
	      		<el-table-column prop="state" label="状态" width="180">
	      			<template slot-scope="scope">
      				<el-tag v-if="scope.row.state==0" type="danger">无效</el-tag>
      				<el-tag v-if="scope.row.state==1" type="success">有效</el-tag>
      			</template>
	      		</el-table-column>
	      		<el-table-column label="操作" width="300">
	      			<template scope="scope">
						<el-button size="small" v-if="scope.row.isVisiable===0" @click="lineToVisiable(scope.$index, scope.row)">置为无效</el-button>
						<el-button size="small" @click="lineUpdate(scope.$index, scope.row)">修改</el-button>
						<el-button size="small" @click="lineCity(scope.$index, scope.row)">目的地列表</el-button>
					</template>
	      		</el-table-column>
	      	</el-table>
	      	<el-pagination background ayout="prev, next" :current-page="currentPage" @current-change="handlerCurrentPage"  :page-size="pageSize" :total="total">
			</el-pagination>


		</div>

	</div>
</template>
<script >
	import {getLineList,visibleLine} from "@/api/api"
	export default {
		data(){
		 	return {
		 		tableData:[],
		 		pageSize:15,
		 		endStand:"",
		 		companyName:"",
		 		total:0,
		 		pageCount:0,
		 		currentPage:0
		 	}
		},
		created:function() {
			var _this = this;

			let params = {pageNum:0,pageSize:this.pageSize};
			getLineList(params).then(res =>{
				this.tableData = res.data.data.list;
				this.total = res.data.data.total;
				this.pageCount=res.data.data.pages;
				this.currentPage = res.data.data.pageNum;
			});
			
		},
		methods:{
			searchLine(){
				this.reload();
			},
			handlerCurrentPage(currentPage){
				let params = {pageNum:currentPage,pageSize:this.pageSize};
				getLineList(params).then(res =>{
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.pageCount = res.data.data.pages;
					this.currentPage = res.data.data.pageNum;
				});
			},
			reload(){
				let params = {pageNum:this.currentPage,pageSize:this.pageSize,companyName:this.companyName,endCity:this.endStand};
				getLineList(params).then(res =>{
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.pageCount = res.data.data.pages;
					this.currentPage = res.data.data.pageNum;
				});
			},
			addLine(){
				this.$router.push({name:"addLine"})
			},
			lineUpdate(index,row){
				this.$router.push({name:"addLine",query:{lineId:row.id}});
			},
			lineCity(index,row){
				this.$router.push({name:"lineCity",query:{lineId:row.id}});
			},
			lineToVisiable(index,row){
				this.$confirm('该操作会替换原来公司展示！','提示',{
			          confirmButtonText: '确定',
			          cancelButtonText: '取消',
			          type: 'warning'
        		}).then(res=>{
        			let param = {lineId:row.id};
        			visibleLine(param).then(res=>{
        				if(res.data.status==="success"){
        					this.$message({
					            type: 'success',
					            message: '操作成功'
					         });
        				}
        				this.reload();
        			});


        		}).catch(() => {
		               
        		});
			}
		}
	}
</script>